import gql from "graphql-tag";
import { fragments } from "../../utils/fragments";

export const FETCH_FAVORITES = gql`
  query($id: ID!) {
    favorites(user: $id) {
      id
      user
      track {
        id
        name
      }
    }
  }
`;
export const SUGGEST_QUERY = gql`
  query(
    $filters: [suggestQuery]
    $randomSortMode: String
    $from: JSON
    $size: Int
    $seed: Int
    $sort: TrackSortOrder
  ) {
    suggest(
      q: $filters
      randomSortMode: $randomSortMode
      from: $from
      size: $size
      seed: $seed
      sort: $sort
    )
  }
`;
export const CREATE_TRACK = gql`
  mutation CreateTrack(
    $title: String
    $name: String
    $variationTitle: String
    $album: ID
    $team: ID
    $variation: Boolean
    $type: TrackType
    $duration: Float
    $thumbnail: String
    $associatedImages: JSON
    $key: String
    $initialBeat: Float
    $bpm: Float
    $mood: Float
    $ensemble: Float
    $density: Float
    $gravity: Float
    $energy: Float
    $melody: Float
    $rhythm: Float
    $tension: Float
    $tags: JSON
    $systemTags: JSON
    $instruments: JSON
    $stem: [StemInput]
    $waveform: String
    $blockFile: [StemInput]
    $freeStemFiles: Boolean
    $description: String
    $publisher: ID
    $parentTrackId: ID
    $order: Int
    $isrc: String
    $price: Float
    $proAffiliation: String
    $stemZip: String
    $trackZip: String
    $mp3File: String
    $wavFile: String
  ) {
    createTrack(
      data: {
        title: $title
        name: $name
        variationTitle: $variationTitle
        album: $album
        team: $team
        variation: $variation
        type: $type
        duration: $duration
        thumbnail: $thumbnail
        associatedImages: $associatedImages
        key: $key
        initialBeat: $initialBeat
        bpm: $bpm
        mood: $mood
        ensemble: $ensemble
        density: $density
        gravity: $gravity
        energy: $energy
        melody: $melody
        rhythm: $rhythm
        tension: $tension
        tags: $tags
        systemTags: $systemTags
        instruments: $instruments
        stem: $stem
        waveform: $waveform
        mp3File: $mp3File
        wavFile: $wavFile
        blockFile: $blockFile
        freeStemFiles: $freeStemFiles
        description: $description
        publisher: $publisher
        parentTrackId: $parentTrackId
        order: $order
        isrc: $isrc
        price: $price
        proAffiliation: $proAffiliation
        stemZip: $stemZip
        trackZip: $trackZip
      }
    ) {
      ...TrackData
    }
  }
  ${fragments.trackQuery}
`;

export const FETCH_TRACKS = gql`
  {
    tracks {
      ...TrackData
    }
  }
  ${fragments.trackQuery}
`;

export const SEARCH = gql`
  query Search(
    $q: String
    $mode: SearchMode!
    $seedTrackId: ID
    $size: Int
    $from: Int
    $filters: [filterQuery]
    $contextId: ID
    $contextType: SearchContext
    $sort: TrackSortOrder
    $seed: Int
  ) {
    search(
      q: $q
      mode: $mode
      seedTrackId: $seedTrackId
      size: $size
      from: $from
      filters: $filters
      contextId: $contextId
      contextType: $contextType
      sort: $sort
      seed: $seed
    ) {
      exact {
        ...TrackData
      }
      suggested {
        ...TrackData
      }
      exactHasMore
      suggestedHasMore
      isFallback
    }
  }
  ${fragments.trackQuery}
`;

export const FETCH_VARIATIONS = gql`
  query($id: ID!) {
    track(id: $id) {
      variationTracks {
        ...TrackData
      }
    }
  }
  ${fragments.trackQuery}
`;

export const FETCH_TRACK = gql`
  query($id: ID!) {
    track(id: $id) {
      ...TrackData
    }
  }
  ${fragments.trackQuery}
`;

export const FETCH_SIMILAR_TRACKS = gql`
  query($id: ID!) {
    similarTracks(id: $id) {
      ...TrackData
    }
  }
  ${fragments.trackQuery}
`;

// TEMP CYANITE ADMIN GATE
export const FETCH_CACHED_SIMILAR_TRACKS = gql`
  query($id: ID!) {
    track(id: $id) {
      similarTracks {
        ...TrackData
      }
    }
  }
  ${fragments.trackQuery}
`;

export const FETCH_STEM_REGIONS = gql`
  query TrackStemRegions($trackId: ID!) {
    trackStemRegions(trackId: $trackId) {
      trackId
      duration
      stems {
        stemName
        stemMp3File
        instrumentName
        regions {
          visualStartTime
          visualDuration
        }
      }
    }
  }
`;

export const GET_AUTOCOMPLETE = gql`
  query AutoComplete($q: String!) {
    autocomplete(q: $q) {
      ... on Track {
        id
        title
        #team
        variation
        variationTitle
        type
        duration
        thumbnail
        #associatedImages
        key
        initialBeat
        bpm
        album {
          id
          name
        }
        mood
        name
        ensemble
        density
        gravity
        energy
        melody
        rhythm
        tension
        tags
        genres
        systemTags
        instruments
        stem {
          name
        }
        waveform
        blockFile {
          name
          wavFile
          mp3File
          #waveform
          #order
        }
        freeStemFiles
        description
        publisher
        parentTrackId
        trackOrder
        isrc
        price
        proAffiliation
        variationTracks {
          id
        }
        created_at
        #stemZip
        #trackZip
      }
      ... on Album {
        id
        name
        price
        description
        thumbnail
        created_at
      }
      ... on Playlist {
        id
        name
        description
        thumbnail
      }
    }
  }
`;

export const GET_ALBUM = gql`
  query Album($id: ID!, $sort: TrackSortOrder) {
    album(id: $id) {
      id
      name
      description
      thumbnail
      created_at
      tracks(sort: $sort) {
        ...TrackData
      }
    }
  }
  ${fragments.trackQuery}
`;

export const GET_PLAYLIST = gql`
  query playlist($id: ID!, $sort: TrackSortOrder) {
    playlist(id: $id) {
      id
      name
      description
      thumbnail
      created_at
      project
      trackOrder
      status
      playlistTracks(sort: $sort) {
        id
        tracks {
          ...TrackData
        }
      }
    }
  }
  ${fragments.trackQuery}
`;

export const DELETE_PLAYLIST_TRACK = gql`
  mutation deletePlaylistTrack($id: ID!) {
    deletePlaylistTrack(id: $id)
  }
`;

export const UPDATE_PLAYLIST_TRACK_ORDER = gql`
  mutation updatePlaylist($id: ID!, $trackOrder: JSON) {
    updatePlaylist(id: $id, data: { trackOrder: $trackOrder }) {
      id
      trackOrder
    }
  }
`;

export const GET_TRACK = gql`
  query Track($id: ID!) {
    track(id: $id) {
      ...TrackData
    }
  }
  ${fragments.trackQuery}
`;

export const REQUEST_SIMILARITY_UPLOAD = gql`
  mutation RequestSimilarityUpload($fileName: String!) {
    requestSimilarityUpload(fileName: $fileName) {
      jobId
      uploadUrl
    }
  }
`;

export const ANALYZE_SIMILARITY_UPLOAD = gql`
  mutation AnalyzeSimilarityUpload($jobId: ID!) {
    analyzeSimilarityUpload(jobId: $jobId) {
      id
      status
      error
    }
  }
`;

export const SIMILARITY_JOB = gql`
  query SimilarityJob($jobId: ID!) {
    similarityJob(jobId: $jobId) {
      id
      status
      fileName
      error
      similarTracks {
        ...TrackData
      }
    }
  }
  ${fragments.trackQuery}
`;
